// @ts-ignore
import get from 'lodash/get';
// @ts-ignore
import set from 'lodash/set';
import { formatEndlessRange, getEndlessRange, fromEndlessRange, } from './format';
import { DATABASE_TYPES } from './constants/index';
const PercentRange = { min: 0, max: 100 };
const InfinityRange = { min: 0, max: Infinity };
const RangeFieldConfig = {
    getValue(settings) {
        return getEndlessRange(get(settings, this.key, {}), PercentRange);
    },
    setValue(settings, value) {
        settings[this.key] = fromEndlessRange(value, PercentRange);
    },
    format: value => formatEndlessRange(value, PercentRange),
};
export const SettingConfigTemplates = {
    sequenceType: {
        key: "sequenceType",
        label: "Search.labels.predicted",
    },
    dbType: {
        key: "dbType",
        label: "Search.labels.database",
        getValue(settings) {
            const val = get(settings, this.key);
            if (val === 'ALL') {
                return [...DATABASE_TYPES];
            }
            return val ? [val] : [];
        },
        setValue(settings, value) {
            if (DATABASE_TYPES.every((t) => value.includes(t))) {
                settings[this.key] = 'ALL';
            }
            else {
                settings[this.key] = value.length ? value[0] : undefined;
            }
        }
    },
    subject_length: {
        key: "subject_length",
        label: "Search.labels.subjectLength",
        getValue(settings) {
            return getEndlessRange(get(settings, this.key, {}), InfinityRange);
        },
        setValue(settings, value) {
            settings[this.key] = fromEndlessRange(value, InfinityRange);
        },
        format(value) {
            return formatEndlessRange(value, InfinityRange);
        },
    },
    multi_subject_length: {
        key: "multi_subject_length",
        label: "Search.labels.subjectLength",
        getValue(settings) {
            return {
                nucleotide: getEndlessRange(get(settings, [this.key, 'nucleotide'], {}), InfinityRange),
                protein: getEndlessRange(get(settings, [this.key, 'protein'], {}), InfinityRange),
            };
        },
        setValue(settings, value) {
            settings[this.key] = {
                nucleotide: fromEndlessRange(get(value, 'nucleotide'), InfinityRange),
                protein: fromEndlessRange(get(value, 'protein'), InfinityRange),
            };
        },
        format(value) {
            const { nucleotide, protein } = value;
            return {
                nucleotide: formatEndlessRange(nucleotide, InfinityRange),
                protein: formatEndlessRange(protein, InfinityRange),
            };
        },
    },
    perc_identity: {
        key: "perc_identity",
        label: "Search.labels.similarity",
        ...RangeFieldConfig,
    },
    q_perc_identity: {
        key: "q_perc_identity",
        label: "Search.labels.queryIdentity",
        ...RangeFieldConfig,
    },
    qcov_hsp_perc: {
        key: "qcov_hsp_perc",
        label: "Search.labels.qconv",
        ...RangeFieldConfig,
    },
    s_perc_identity: {
        key: "s_perc_identity",
        label: "Search.labels.subjectIdentity",
        ...RangeFieldConfig,
    },
    scov_hsp_perc: {
        key: "scov_hsp_perc",
        label: "Search.labels.subjectCoverage",
        ...RangeFieldConfig,
    },
    limit: {
        key: "limit",
        label: "Search.labels.targetSeqLimit",
    },
    ungapped: {
        key: "ungapped",
        label: "Search.labels.gaps",
    },
    evalue: {
        key: "evalue",
        label: "Search.labels.evalue",
    },
    low_complexity_region: {
        key: "low_complexity_region",
        label: "Search.labels.lowComplexRegion",
    },
    automatic: {
        key: "algorithmSettings.automatic",
        label: "Search.labels.defaultAlgorithm",
    },
    algorithm: {
        key: "algorithmSettings.algorithm",
        label: "Search.labels.algorithm",
    },
    matrix: {
        key: "algorithmSettings.matrix",
        label: "Search.labels.matrix",
    },
    word_size: {
        key: "algorithmSettings.word_size",
        label: "Search.labels.wordSize",
        getValue(settings) {
            return `${get(settings, this.key, '0')}`;
        },
    },
    match_scores: {
        key: "algorithmSettings.match_scores",
        label: "Search.labels.matchScores",
    },
    gaps: {
        key: "algorithmSettings.gaps",
        label: "Search.labels.gapCosts",
    },
    // 修饰检索
    algorithm_type: {
        key: "algorithm_type",
        label: "Search.labels.algorithmType",
    },
    gap_extend: {
        key: "gap_extend",
        label: "Search.labels.gapExtend",
    },
    gap_open: {
        key: "gap_open",
        label: "Search.labels.gapOpen",
    },
    score_matrix: {
        key: "score_matrix",
        label: "Search.labels.scoreMatrix",
    }
};
export class SettingConfig {
    constructor(config) {
        this.active = false;
        Object.assign(this, config);
    }
    getValue(settings) {
        return get(settings, this.key, this.defaultValue);
    }
    setValue(settings, value) {
        set(settings, this.key, value);
    }
    format(value) {
        return value;
    }
}
export const createSettingConfig = (name) => {
    const temp = SettingConfigTemplates[name];
    return new SettingConfig(temp);
};
export const registerSettingConfig = (name, config) => {
    return SettingConfigTemplates[name] = config;
};
